import React, { Component, PropTypes } from 'react';
import * as RefApi from 'saas/references/api';
import dotProp from 'dot-prop-immutable';
import * as RefConstants from 'saas/references/constants';
import {
  Dropdown,
  Form,
  FormDropdown,
  Header,
  Input,
  Label,
  Segment,
  Button,
} from 'semantic-ui-react';
import Datepicker from 'common/components/Datepicker';
import Timepicker from 'common/components/Timepicker';
import PreplannificationInput from 'saas/aast/common/components/PreplannificationInput';
import moment from 'moment';
import { DATE_FORMAT } from 'common/components/PreplanificationSelection';
import { scheduleFromModal, getSchedule } from '../api';
import { error } from 'plugins/toastr';

class PlanningModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      planningDate: undefined,
      planningTime: undefined,
      preplanningDate: undefined,
      visitDuration: undefined,
      visitDurationUnit: undefined,
      workerId: undefined,
      secondaryWorkerIds: [],
      timeUnits: [],
      errors: [],
      isLoaded: false,
    };

    this._renderPrimaryWorkersOptions = this._renderPrimaryWorkersOptions.bind(
      this
    );
    this._renderSecondaryWorkersOptions = this._renderSecondaryWorkersOptions.bind(
      this
    );
    this._updateValue = this._updateValue.bind(this);
    this._onSave = this._onSave.bind(this);
  }

  componentDidMount() {
    if (this.props.id.includes('PCO')) {
      RefApi.getReferencesByType(
        RefConstants.TIME_UNIT,
        this.props.caseId
      ).then(resp =>
        this.setState({
          ...this.state,
          timeUnits: resp,
          visitDurationUnit: resp[0].id,
        })
      );
    } else {
      RefApi.getAASTReferencesByType(
        RefConstants.TIME_UNIT,
        this.props.caseId
      ).then(resp =>
        this.setState({
          ...this.state,
          timeUnits: resp,
          visitDurationUnit: resp[0].id,
        })
      );
    }

    getSchedule(this.props.id).then(res => {
      this.setState({
        ...this.state,
        ...res,
        isLoaded: true,
      });
    });
  }

  _renderPrimaryWorkersOptions() {
    return this.props.workers
      .filter(w => !w.deleted || this.state.workerId === w.id)
      .map(w => ({
        key: w.id,
        text: w.name,
        value: w.id,
      }));
  }

  _renderSecondaryWorkersOptions() {
    return this.props.workers
      .filter(
        w => this.state.workerId === undefined || this.state.workerId !== w.id
      )
      .filter(w => !w.deleted || this.state.secondaryWorkerIds.includes(w.id))
      .map(w => ({
        key: w.id,
        text: w.name,
        value: w.id,
      }));
  }

  _updateValue(name, value) {
    this.setState(dotProp.set(this.state, name, value));
  }

  _onSave() {
    const errors = [];

    if (errors.length === 0) {
      scheduleFromModal(this.props.id, {
        ...this.state,
      }).then(
        _ => location.reload(),
        err => {
          if (err.res.status === 409) {
            err.res.json().then(res => error(res.label));
          } else {
            error('Une erreur est survenue pendant la plannification');
            console.log('Unknown error: ' + err);
          }
        }
      );
    } else {
      this.setState({
        ...this.state,
        errors: errors,
      });
    }
  }

  render() {
    const {
      timeUnits,
      planningDate,
      planningTime,
      preplanningDate,
      visitDuration,
      visitDurationUnit,
      workerId,
      secondaryWorkerIds,
      errors,
      isLoaded,
    } = this.state;

    return (
      <Form>
        <Segment basic>
          <Header as="h3">Replanifier</Header>
        </Segment>
        <Segment basic loading={!isLoaded}>
          <Form.Group>
            <Form.Field width={8}>
              <label>Date ou semaine</label>
              <Form.Group>
                <Form.Field width={6}>
                  <Datepicker
                    identifier="date"
                    name="planningDate"
                    value={planningDate || ''}
                    onChange={v =>
                      this._updateValue(
                        'planningDate',
                        moment(v.date).format(DATE_FORMAT)
                      )
                    }
                    placeholder="JJ/MM/AAAA"
                  />
                </Form.Field>
                <Form.Field width={3}>
                  <Timepicker
                    name="planningTime"
                    value={planningTime || ''}
                    onChange={v => this._updateValue('planningTime', v)}
                  />
                </Form.Field>
                <Form.Field width={1} style={{ paddingTop: '7px' }}>
                  <Label circular color="grey">
                    ou
                  </Label>
                </Form.Field>
                <Form.Field width={6}>
                  <PreplannificationInput
                    name="preplanningDate"
                    value={preplanningDate || ''}
                    onChange={v => this._updateValue('preplanningDate', v)}
                    placeholder="Semaine"
                  />
                </Form.Field>
              </Form.Group>
            </Form.Field>
            <Form.Field width={8}>
              <label>Durée de l'intervention</label>
              <Input
                value={visitDuration || ''}
                type="number"
                error={errors.includes('visitDuration')}
                label={
                  <Dropdown
                    value={visitDurationUnit || ''}
                    options={timeUnits.map(tu => ({
                      key: tu.id,
                      text: tu.label,
                      value: tu.id,
                    }))}
                    basic
                    onChange={(_, value) =>
                      this._updateValue('visitDurationUnit', value.value)
                    }
                  />
                }
                labelPosition="right"
                placeholder="Durée"
                onChange={evt =>
                  this._updateValue(
                    'visitDuration',
                    parseInt(evt.target.value, 0)
                  )
                }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <FormDropdown
              label="Technicien"
              selection
              options={this._renderPrimaryWorkersOptions()}
              value={workerId || ''}
              onChange={(_, value) =>
                this._updateValue('workerId', value.value)
              }
              width={5}
            />
            <FormDropdown
              label="Techniciens secondaires"
              selection
              multiple
              options={this._renderSecondaryWorkersOptions()}
              value={secondaryWorkerIds}
              onChange={(_, value) =>
                this._updateValue('secondaryWorkerIds', value.value)
              }
              width={11}
            />
          </Form.Group>
        </Segment>
        <Segment textAlign="right">
          <div className="actions">
            <Button onClick={this.props.onClose}>Annuler</Button>
            <Button onClick={this._onSave} primary>
              Enregistrer
            </Button>
          </div>
        </Segment>
      </Form>
    );
  }
}

PlanningModal.propTypes = {
  id: PropTypes.string.isRequired,
  caseId: PropTypes.number.isRequired,
  workers: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PlanningModal;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/modal/PlanningModal.js